import styled from "styled-components"
import {
	UserManagementCentreWrapper,
	IUserManagementCentreWrapperProps,
} from "../userManagementCentre/styles"

export const EditUserManagementCentreWrapper = styled(
	UserManagementCentreWrapper
)<IUserManagementCentreWrapperProps>``
